export const niceDate = (dateIn, expandToday, suffixUhr) => {    
    const dateNow = new Date();
    var ms = new Date().getTime() - 86400000;
    var dateYesterday = new Date(ms);
  
    var time = String(dateIn.getHours()).padStart(2, '0') + ':' + String(dateIn.getMinutes()).padStart(2, '0');
    var date = String(dateIn.getDate()).padStart(2, '0') + '.' + String((dateIn.getMonth()+1)).padStart(2, '0') + '.' + dateIn.getFullYear();
    var dateToday = String(dateNow.getDate()).padStart(2, '0') + '.' + String((dateNow.getMonth()+1)).padStart(2, '0') + '.' + dateNow.getFullYear();

    if (
      dateIn.getDate() == dateYesterday.getDate() &&
      dateIn.getMonth() == dateYesterday.getMonth() &&
      dateIn.getFullYear() == dateYesterday.getFullYear())
      {
        return 'Gestern';
      }
    else if (date == dateToday)
      {
        if (expandToday == 0) { return 'Heute' }
        if (expandToday == 1) { return time }
        if (expandToday == 2) { return 'Heute ' + time }        
      }
    else 
      {
        return date;
      }      
    }
  